import { Component, Input, OnInit } from "@angular/core";
import { TranslationService } from "../../../_services/translation.service";
import { EventsService } from "../../../_services/eventsServices/events.service";
import { UserManagementService } from "../../../_services/user-management.service";
import { FormGroup, FormGroupDirective } from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import { UserPrivilegeType } from "../user-management-models/user-privilege-type.enum";

@Component({
  selector: "user-management-form-password-management",
  templateUrl: "./user-management-form-password-management.component.html",
  styleUrls: ["./user-management-form-password-management.component.scss"],
})
export class UserManagementFormPasswordManagementComponent implements OnInit {
  @Input("userId")
  public userId: "new" | string = "new";
  public translations$: Observable<ITranslations>;
  public systemPrivilegesForm: FormGroup;
  public UserPrivilegeType = UserPrivilegeType;
  public areLimitedPrivilegesShown = false;
  public refundPasswordVisibility = false;

  constructor(
    private translationService: TranslationService,
    private usesManagementService: UserManagementService,
    private userSystemPrivileges: FormGroupDirective
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit() {
    this.systemPrivilegesForm = this.userSystemPrivileges.form;
  }

  public changePrivilegeHandler(value: string) {
    this.areLimitedPrivilegesShown = value === UserPrivilegeType.Limited;
  }

  public toggleVisibility($event: MouseEvent) {
    $event.preventDefault();
    this.refundPasswordVisibility = !this.refundPasswordVisibility;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-form-password-management/user-management-form-password-management.component.ts